// src/components/InfoModal.jsx
import React from 'react';
import { Box, Typography, Modal } from '@mui/material';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 18%)',
  maxHeight: '90vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 3,
  borderRadius: 1,
  focusVisible: false,
};

const SingleTeamInfoModal = ( { open, handleClose, info } ) => {
    if (!info) return null;
    
  return (
    <AnimatePresence>
       {open && (
          <Modal
          keepMounted 
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          hideBackdrop={false} 
          // BackdropProps={{ onClick: (e) => e.stopPropagation() }}
        >
          <motion.div
              initial={{ opacity: 0, width: 0 }}
              animate={{ opacity: 1, width: '90%' }}
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: 0.4 }}
            >    
          <Box sx={style}>
            <Container>
              <Row>
                <Col xs={12} md={4} className='mb-5 mb-md-0 mb-lg-0' >
                  <Image src={info.image} alt={info.name} style={{ width: '100%', borderRadius: '8px' }} />
                </Col>
                <Col xs={12} md={8} style={{ padding: '20px', backgroundColor: '#2942521a', borderRadius: '8px' }}>
                    <Typography variant="h2" sx={{ fontSize: '40px', fontWeight: '600', color: '#294252' }}>
                      {info.name}
                    </Typography>
                    <Typography variant="subtitle1" component="p" sx={{ color: '#000',width: 'fit-content', backgroundColor: '#ccc', padding: '4px 12px', borderRadius: '4px', margin: '10px 0' }}>
                      {info.designation}
                    </Typography>
                    <Typography variant="subtitle1" component="p">
                      {info.description}
                    </Typography>
                </Col>
              </Row>
            </Container>
          </Box>
        </motion.div>

        </Modal>
        )}
    </AnimatePresence>
  );
};

export default SingleTeamInfoModal;
